export enum ContentTypes {
  Json = 'application/json',
  MultiPartFormData = 'multipart/form-data',
}
